import React from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ products, onAdd,cart }) => (
  <div className="d-flex flex-wrap gap-3">
    {products.map(product => (
      <ProductCard key={product.ID} product={product} cart={cart} onAdd={onAdd} />
    ))}
  </div>
);

export default ProductGrid;
